<template>
    <div class="app">
        <router-view></router-view>
        <!-- <feedBack
            v-if="userInfo.user && userInfo.token"
            :env="env"
            :lang="lang"
            :classify="classify"
            :userInfo="userInfo"
            :componentBottom="componentBottom"
            ref="feedbackRef"
            :tabs="tabs"
            :whetherTheCoexistence="whetherTheCoexistence"
            :configInfo="configInfo"
            :intimeevaluateUserInfo="intimeevaluate.userInfo"
            :intimeevaluateTempleteInfo="intimeevaluate.templeteInfo"
        /> -->
        <FeedBack />
        <NotificationWarn />
        <BankWarn />
        <PerformRectifyNotice />
        <ArbitrationNotice />
        <template v-if="bidNoticeList.length">
            <bidPlanNotice v-show="bidMessageState" v-for="item in bidNoticeList" :bidNoticeData="item" :key="item.binNo"/>
        </template>
    </div>
</template>
<script>
// import FeedBack from 'itsm-feedback-v2';
// import config from '@/config/user.env.js';
import FeedBack from './components/feedback/Index.vue';
import NotificationWarn from './components/NotificationWarn/Index.vue';
import BankWarn from './components/BankWarn.vue';
import PerformRectifyNotice from './components/performRectifyNotice/Index.vue';
import ArbitrationNotice from './components/arbitrationNotice/Index.vue';
import bidPlanNotice from './components/bidPlanNotice/Index.vue';
import {
    getBidSearchInfoInviteTip
} from './api/notificationWarn.js';

export default {
    name: 'app',
    components: { FeedBack,NotificationWarn, BankWarn, PerformRectifyNotice, ArbitrationNotice, bidPlanNotice },
    data () {
        return {
            bidNoticeList: [],
            bidMessageState: false
            // env: config.env.toLowerCase(), // "sit"，"uat"，"prod"  三种环境，prod是生产环境可以不写env属性
            // classify: {
            //     oneClassifyCode: config.oneClassifyCode, // 填写自己项目的一级分类
            //     twoClassifyCode: config.twoClassifyCode, // 填写自己项目的二级分类
            //     threeClassifyCode: config.threeClassifyCode // 填写自己项目的三级分类
            // },
            // componentBottom: 50, // 调整组件底部距离，(有默认值可以不传)
            // tabs: [ // 菜单名称(最多4个)
            //     {
            //         unique: 'IT5000',
            //         name: 'IT5000',
            //         icon: 'feedback-tool-filled',
            //         jumpUrl: ''
            //     },
            //     {
            //         unique: 'message',
            //         name: '我的消息',
            //         icon: 'feedback-message',
            //         jumpUrl: ''
            //     },
            //     {
            //         unique: 'advice',
            //         name: '我要建议',
            //         icon: 'feedback-edit-filledbeifen',
            //         jumpUrl: ''
            //     }
            // ],
            // whetherTheCoexistence: true // 我要反馈与我要评价是否共存
        };
    },
    mounted() {
        setTimeout(() => {
            this.init();
        }, 3000);
    },
    methods: {
        init() {
            const value = sessionStorage.getItem("bidMessageState");
            if (!value) {
                this.bidMessageState = true;
                sessionStorage.setItem("bidMessageState", true);
                this.getData();
            } else {
                this.bidMessageState = false;
            }
        },
        getData() {
            if (!this.$store.state.supplier.supplierCode) {
                return false;
            }
            const params = {
                supplierCode: this.$store.state.supplier.supplierCode
            };
            getBidSearchInfoInviteTip(params).then(res => {
                if (res && +res.code === 0) {
                    const bidNoticeList = res.data;
                    // const bidNoticeList = [
                    //     {
                    //         bidNo: '招标编码',
                    //         messageContent: '提示内容'
                    //     }
                    // ];
                    if (Array.isArray(bidNoticeList)) {
                        this.bidNoticeList = bidNoticeList;
                    }
                }
            });
        }
    }
    // computed: {
    //     lang() { // 国际化语言：zh-CN | en-US | ja-JP
    //         return this.$store.state.lang.locale;
    //     },
    //     userInfo() {
    //         return {
    //             user: this.$store.state.user.userCode, // 优先传手机号，若无手机号则传userCode
    //             messageSystem: 'C-LSRM', // 接入我的消息系统
    //             systemId: config.systemId, // 填写项目的系统id
    //             productId: config.productId, // 填写项目的产品id
    //             token: this.$store.state.itsmToken // 外网访问需要token
    //         };
    //     },
    //     intimeevaluate() {
    //         return {
    //             userInfo: {
    //                 user_name: this.$store.state.user.userName, // mip账号（姓名）
    //                 user_id: this.$store.state.contactsMobile || this.$store.state.user.userCode // mip账号
    //             },
    //             templeteInfo: {
    //                 appType: 'pc', // 终端类型 pc、app
    //                 modeType: 'hover', // 弹框挂件展示类型 hover: 挂件式(悬浮右下角) inner:嵌入  默认:''不展示任何挂件
    //                 business: '安得智联', // 领域 eg: 内销领域
    //                 system: 'C-LSRM', // 系统 eg: 美云销
    //                 product: 'PRM合作伙伴关系管理', // 产品 eg: TPC交易与履约中心
    //                 scene: 'LSP-首页', // 投放位置, 挂件式一般放页面右下角，eg: 人才搜索右侧
    //                 primaryColor: '', // 提交按钮的主色调,默认：#0888ff
    //                 hoverBtnColor: '', // 提交按钮在hover时候的颜色， 默认：#39a0ff
    //                 hoverTagColor: '' // tag标签在hover时候的颜色 默认：#ebf5ff
    //             }
    //         };
    //     },
    //     configInfo() {
    //         return {
    //             screenshotsMode: 2,
    //             isMobile: true,
    //             autoFillMobile: this.$store.state.contactsMobile || null
    //         };
    //     }
    // }
};
</script>
<style lang="less">
#app, .app {
    height: 100%;
}
</style>
